import React, { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIntersection } from 'react-use';

import useIsBrowser from 'hooks/useIsBrowser';
import ModularProductCard from './ModularProductCard';

const ModularTopNavItems = ({
  isNavFixed = false,
  collectionData,
  collectionInView,
  onTopNavClick,
}) => (
  <>
    {collectionData.map(collection => (
      <ModularProductCard
        key={collection.name}
        className={cx({
          '![border-bottom:2px_solid_#107c8c]':
            isNavFixed && collectionInView === collection.id,
        })}
        product={{
          ...collection.products[0],
          options: collection.options,
          collection: collection.name,
        }}
        displayType="collection"
        onClick={() => {
          if (onTopNavClick) {
            onTopNavClick(collection.id);
          }
        }}
        isFixed={isNavFixed}
        collectionInView={collectionInView}
        thumbnail={collection.thumbnail}
      />
    ))}
  </>
);

const ModularTopNav = ({
  collectionData = [],
  onTopNavClick = null,
  collectionInView = 0,
}) => {
  const navRef = useRef(null);
  const isBrowser = useIsBrowser();

  const intersection = useIntersection(navRef, { threshold: 0.3 });
  const isStaticNavVisible = intersection ? intersection.isIntersecting : true;
  const isNavFixed = isBrowser && !isStaticNavVisible;

  return (
    <>
      <div
        ref={element => {
          navRef.current = element;
        }}
        className="bg-white w-full max-[767px]:p-5 pt-12"
      >
        <div className="grid grid-cols-[repeat(auto-fit,minmax(130px,48%)_)] gap-[10px] md:flex md:flex-wrap md:items-center md:justify-center">
          <ModularTopNavItems
            collectionData={collectionData}
            collectionInView={collectionInView}
            onTopNavClick={onTopNavClick}
          />
        </div>
      </div>

      <div
        className={cx(
          'bg-white w-full h-[54px] left-0 opacity-0 pointer-events-none fixed top-0 transition-[opacity_.2s_ease-out] z-[5000] max-[767px]:p-0',
          {
            'opacity-100 pointer-events-auto transition-[opacity_.2s_ease-in]': isNavFixed,
          }
        )}
      >
        <div className="md:items-center md:justify-center bg-white [border-bottom:1px_solid_#e5e5e5] flex flex-row flex-nowrap w-full max-[767px]:overflow-x-auto">
          <ModularTopNavItems
            isNavFixed
            collectionData={collectionData}
            collectionInView={collectionInView}
            onTopNavClick={onTopNavClick}
          />
        </div>
      </div>
    </>
  );
};

ModularTopNavItems.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func,
  collectionInView: PropTypes.number,
  isNavFixed: PropTypes.bool,
};

ModularTopNav.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func,
  collectionInView: PropTypes.number,
};

export default ModularTopNav;
